import {menuStore} from "./app-store.js";

export const previewListener = () => {
    window.addEventListener('message', (e) => {
        if (e.data.id === 'dmPreviewUpdate') {
            if (e.data.menu) {
                menuStore.set(JSON.parse(JSON.stringify(e.data.menu)));
            }
        }
    });
}

